import axios from "axios";
import { getTokens, saveTokens, resetTokens } from "../utils/cache"

export default class Service {

  /**
   * Create a Service.
   */
  constructor() {
    this.BACKEND_URL =  process.env.REACT_APP_BACKEND_URL || '';
  }

  /**
   * Ajax request
   */  
  ajax(data, lastOpportunity = false) {
    return new Promise(async (resolve, reject) => {
      let errorMsg;
      let accessToken = '';
      let refreshToken = '';

      // Set config
      var config = {
        method: data.method,
        url: `${data.baseUrl}/${data.path}`,
      };
      // console.log('apiService > config.url', config.url);
      if (!!data.headers) config.headers = data.headers;
      if (!!data.body) config.data = data.body;
      if (!!data.responseType) config.responseType = data.responseType;

      // Add access token as bearer
      const addBearer = data.bearerIsNeeded !== false;
      if (addBearer) {
        // Get tokens from localStorage
        const tokens = getTokens();
        if (!tokens.access_token || !tokens.refresh_token) {
          this.wipeOut();
          return reject("Unauthorized");
        }
        // console.log('apiService > ajax > Adding bearer, tokens', tokens);
        accessToken = tokens.access_token;
        refreshToken = tokens.refresh_token;
        if (!config.headers) config.headers = {};
        config.headers['Authorization'] = `Bearer ${accessToken}`;
      }

      // Request
      try {
        const response = await axios(config);
        // console.log('Response', response);
        if (response.status === 200 || response.status === 201) {
          resolve(response.data);
        } else {
          errorMsg = "Unexpected error";
          console.log(`Error: ${errorMsg}, response:`, response);
          reject(errorMsg);
        }
      } catch (error) {    
        console.log('error', error);  
        if (
          !!error.response && 
          addBearer && 
          (error.response.status === 403 || error.response.data === "El token ha expirado")
          ) {
          // 401 (Forbidden = Expired token)
          try {
            const response = await axios({
              url: `${this.BACKEND_URL}/renewTokens?refresh_token=${refreshToken}`,
              method: "GET",
            });
            const newtokens = response.data;
            console.log('Refreshing tokens', newtokens);
            // Save new tokens
            saveTokens(newtokens);
            // Return the new AJAX call to chain promises correctly
            try {
              const newdata = JSON.parse(JSON.stringify(data));
              return resolve(await this.ajax(newdata));                    
            } catch (error) {
              errorMsg = this.getError(error);
              console.log(`Error calling the second request. ${errorMsg}`);
              reject(errorMsg);
            }
          } catch (error) {
            if (!lastOpportunity) {
              // Last opportunity
              try {
                const newdata = JSON.parse(JSON.stringify(data));
                console.log('Calling Last opportunity!!', newdata);
                return resolve(await this.ajax(newdata, true));                    
              } catch (error) {
                errorMsg = this.getError(error);
                console.log(`Error calling the last opportunity request. ${errorMsg}`);
                reject(errorMsg);
              }
            } else {
              errorMsg = this.getError(error);
              console.log(`Error refreshing token. ${errorMsg}`);
              this.wipeOut();
              reject(errorMsg);
            }
          }
        } else {
          errorMsg = this.getError(error);
          reject(errorMsg);
        }
      }
    });
  }

  getError(error) {
    let errorMsg;
    if (!!error.response && typeof error.response.data === "string") {
      errorMsg = error.response.data;
      if (!!error.response.statusText) {
        errorMsg += ` (${error.response.statusText})`;
      }
    } else if (!!error.message) {
      errorMsg = `${error.message} (${error.code})`;
    } else {
      errorMsg = error;
    }
    return errorMsg;
  }

  /**
   * Reset app
   */ 
  wipeOut() {
    console.warn("wipeOut!!!!")
    resetTokens();
    setTimeout(() => {
      window.location.href = "/";
    }, 2000);
  }

  /**
   * Get form data (multi-part) Files and Metadata
   */   
  getFormData(data) {
    // console.log('getFormData > data', data);
    const formData = new FormData();
    const files = [];
    const filesMetadata = [];

    data.forEach((item) => {
      const { file, ...metadata } = item;
      if (file) {
        files.push(file);
      }
      filesMetadata.push(metadata);
    });

    files.forEach((file) => {
      formData.append("files", file);
    });
    formData.append("files_metadata", JSON.stringify(filesMetadata));    
    // console.log('getFormData > formData', formData);
    return formData;
  }

}
